import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Modal } from '../Modal';
import styles from './modalReload.module.sass';
import { IconSVG } from '../SpriteSVG';
import { Button } from '../Button';
import { useAuthStore } from '../../providers/RootStoreProvider';

export const ModalReload = () => {
  const store = useAuthStore();
  const { isManager } = store;

  const router = useRouter();
  // Состояние для отслеживания видимости модального окна
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Состояние для хранения момента времени открытия страницы
  const [pageOpenTime] = useState(new Date());

  useEffect(() => {
    // Функция для проверки, прошло ли 15 минут
    const checkTime = () => {
      if (new Date() - pageOpenTime > 15 * 60 * 1000) {
        setIsModalOpen(true);
      }
    };

    // Запуск интервала
    const interval = setInterval(checkTime, 60 * 1000); // Проверяем каждую минуту

    // Очистка интервала
    return () => clearInterval(interval);
  }, [pageOpenTime]);

  // Функция для перезагрузки страницы
  const handleReload = () => {
    router.reload();
  };

  return (
    <>
      {!isManager && (
        <Modal
          isOpen={isModalOpen}
          onOpen={setIsModalOpen}
          title="Данные устарели"
          size="dialog"
          centerHeader
          hideCross
          noClickAway
        >
          <div className={styles.modalReload}>
            <IconSVG name={'common/reload'} width={86} height={86} />
            <p>Наличие мест и цены могли измениться.</p>
            <Button view="buttonModalData" size="lg" onClick={handleReload}>
              Перезагрузить страницу
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};
